
import { Component, Vue } from 'vue-property-decorator'
import {
  CreateLeakReason,
  UpdateLeakReason,
  DeleteLeakReason,
  ListLeakReasons
} from '@/api/baseData'
import { ILeakReason } from '@/api/types'

@Component({
  name: 'LeakReasonTab'
})
export default class extends Vue {
  private list: ILeakReason[] = []
  private listLoading = false

  private dialogFormVisible = false
  private dialogStatus = ''
  private temp: ILeakReason = {
    id: -1,
    desc: '',
  }

  private rules = {
    desc: [{ required: true, message: '请输入原因名称', trigger: 'blur' }],
  }

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    try {
      const { data } = await ListLeakReasons()
      this.list = data || []
    } catch (error) {
      console.error('获取漏水原因列表失败', error)
    } finally {
      this.listLoading = false
    }
  }

  private resetTemp() {
    this.temp = {
      id: -1,
      desc: '',
    }
  }

  private handleCreate() {
    this.resetTemp()
    this.dialogStatus = 'create'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async createData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        try {
          await CreateLeakReason(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建漏水原因成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        } catch (error) {
          console.error('创建漏水原因失败', error)
        }
      }
    })
  }

  private handleUpdate(row: any) {
    this.temp = Object.assign({}, row)
    this.dialogStatus = 'update'
    this.dialogFormVisible = true
    this.$nextTick(() => {
      (this.$refs.dataForm as any).clearValidate()
    })
  }

  private async updateData() {
    (this.$refs.dataForm as any).validate(async(valid: boolean) => {
      if (valid) {
        const tempData = Object.assign({}, this.temp)
        try {
          if (tempData.id !== undefined) {
            const updateData = {
              id: Number(tempData.id),
              desc: tempData.desc,
            }
            await UpdateLeakReason(updateData)
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新漏水原因成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          }
        } catch (error) {
          console.error('更新漏水原因失败', error)
        }
      }
    })
  }

  private async handleDelete(row: any) {
    this.$confirm('确认删除该漏水原因?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      try {
        await DeleteLeakReason({ id: row.id })
        this.$notify({
          title: '成功',
          message: '删除漏水原因成功',
          type: 'success',
          duration: 2000
        })
        this.getList()
      } catch (error) {
        console.error('删除漏水原因失败', error)
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
}
